// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__25R6k","notes":"Notes_notes__2jjZS","note":"Notes_note__1JKB0","markdown":"Notes_markdown__1HxKo"};